export var balanceAndNotificationServiceDataSelector = function (state) { return state && state.content; };
export var balanceAndNotificationServiceUserHasNewNotificationsSelector = function (state) {
    return state.content.hasNewNotifications;
};
export var balanceAndNotificationServiceUserHasUnreadNotificationsSelector = function (state) {
    return state.content.hasUnreadNotifications;
};
export var balanceAndNotificationServiceLoadingSelector = function (state) { return Boolean(state.loading); };
export var balanceAndNotificationServiceInitializedSelector = function (state) {
    return Boolean(state.initialized);
};
export var balanceAndNotificationServiceTealBalanceSelector = function (state) {
    return Number(state.content.tealBalance);
};
export var balanceAndNotificationServiceThanksBalanceSelector = function (state) {
    return Number(state.content.thankBalance);
};
export var balanceAndNotificationServiceSupervisorBalanceSelector = function (state) {
    return Number(state.content.supervisorBalance);
};
export var balanceAndNotificationServiceBenefitBalanceSelector = function (state) {
    return Number(state.content.benefitBalance);
};
